import { useState } from "react";
import "./editorialForms.css";

export default function CourseForm({ data, onChange }) {
  const [moduleInput, setModuleInput] = useState("");

  const categories = [
    "Programacao",
    "Design",
    "Marketing",
    "Negocios",
    "Financas",
    "Idiomas",
    "Musica",
    "Fotografia",
    "Saude",
    "Desenvolvimento Pessoal",
    "Academico",
    "Outro",
  ];

  const levels = [
    { id: "beginner", name: "Iniciante" },
    { id: "intermediate", name: "Intermediario" },
    { id: "advanced", name: "Avancado" },
    { id: "all", name: "Todos os niveis" },
  ];

  const currencies = ["BRL", "USD", "EUR"];

  const handleAddModule = () => {
    if (moduleInput.trim()) {
      onChange({
        ...data,
        modules: [...(data?.modules || []), { title: moduleInput.trim(), lessons: 0 }],
      });
      setModuleInput("");
    }
  };

  const handleRemoveModule = (index) => {
    onChange({
      ...data,
      modules: (data?.modules || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="editorial_form course_form">
      <div className="editorial_form_section">
        <label>
          Titulo do Curso <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Desenvolvimento Web Completo"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descricao</label>
        <textarea
          placeholder="Descreva o que o aluno vai aprender..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={3000}
          rows={4}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Categoria</label>
          <select
            value={data?.category || ""}
            onChange={(e) => onChange({ ...data, category: e.target.value })}
          >
            <option value="">Selecione</option>
            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Nivel</label>
          <select
            value={data?.level || "all"}
            onChange={(e) => onChange({ ...data, level: e.target.value })}
          >
            {levels.map((lvl) => (
              <option key={lvl.id} value={lvl.id}>
                {lvl.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Modulos
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddModule}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Nome do modulo"
          value={moduleInput}
          onChange={(e) => setModuleInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddModule()}
        />
        <div className="genre_chips" style={{ marginTop: "8px" }}>
          {(data?.modules || []).map((mod, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveModule(i)}
              style={{ cursor: "pointer" }}
            >
              {mod.title} x
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Duracao Total (horas)</label>
          <input
            type="number"
            placeholder="Ex: 40"
            value={data?.totalHours || ""}
            onChange={(e) =>
              onChange({ ...data, totalHours: parseInt(e.target.value) || 0 })
            }
          />
        </div>

        <div className="editorial_form_section">
          <label>Numero de Aulas</label>
          <input
            type="number"
            placeholder="Ex: 120"
            value={data?.totalLessons || ""}
            onChange={(e) =>
              onChange({ ...data, totalLessons: parseInt(e.target.value) || 0 })
            }
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Preco</label>
        <div className="editorial_form_row">
          <select
            className="currency_select"
            value={data?.price?.currency || "BRL"}
            onChange={(e) =>
              onChange({
                ...data,
                price: { ...data?.price, currency: e.target.value },
              })
            }
          >
            {currencies.map((cur) => (
              <option key={cur} value={cur}>
                {cur}
              </option>
            ))}
          </select>
          <div className="price_input">
            <span className="currency_prefix">R$</span>
            <input
              type="number"
              step="0.01"
              placeholder="0.00"
              value={data?.price?.amount || ""}
              onChange={(e) =>
                onChange({
                  ...data,
                  price: {
                    ...data?.price,
                    amount: parseFloat(e.target.value) || 0,
                  },
                })
              }
            />
          </div>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Opcoes</label>
        <div className="editorial_form_checkboxes">
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="hasCertificate"
              checked={data?.hasCertificate || false}
              onChange={(e) =>
                onChange({ ...data, hasCertificate: e.target.checked })
              }
            />
            <label htmlFor="hasCertificate">Oferece certificado</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="hasLifetimeAccess"
              checked={data?.hasLifetimeAccess || false}
              onChange={(e) =>
                onChange({ ...data, hasLifetimeAccess: e.target.checked })
              }
            />
            <label htmlFor="hasLifetimeAccess">Acesso vitalicio</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="hasSupport"
              checked={data?.hasSupport || false}
              onChange={(e) =>
                onChange({ ...data, hasSupport: e.target.checked })
              }
            />
            <label htmlFor="hasSupport">Suporte do instrutor</label>
          </div>
        </div>
      </div>

      <div className="editorial_form_tip course_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
        </svg>
        <span>
          Crie e venda cursos online. Adicione aulas em video, material de apoio
          e certificado de conclusao.
        </span>
      </div>
    </div>
  );
}
